import {Pipe, PipeTransform} from "@angular/core";
import {DateTime} from 'luxon';
import {capitalize} from '../strings';


@Pipe({
  name: 'showEventDatetime'
})
export class ShowEventDatetime implements PipeTransform {
  transform(date: number): string {
    return capitalize(DateTime.fromMillis(date).setLocale('fr').toFormat("cccc DD à HH:mm"))
  }
}
